import { Component, OnInit } from '@angular/core';
import {StateService} from '../state.service';
import {User} from '../models/User';
import {Certificate} from '../models/certificate';
import {CertificateValiditySummary} from './CertificateValiditySummary';
import * as moment from 'moment';
import {Moment} from 'moment';
import {CertificateGroup} from './CertificateGroup';
import {CertificateUserGroup} from './CertificateUserGroup';
import {ExpiringCertificate} from './ExpiringCertificate';

@Component({
  selector: 'app-statistics-page',
  templateUrl: './statistics-page.component.html',
  styleUrls: ['./statistics-page.component.css']
})
export class StatisticsPageComponent implements OnInit {

  public data: any = [{
    name: 'Germany',
    value: 40632
  }, {
    name: 'United States',
    value: 49737
  }, {
    name: 'France',
    value: 36745
  }, {
    name: 'United Kingdom',
    value: 36240
  }, {
    name: 'Spain',
    value: 33000
  }, {
    name: 'Italy',
    value: 35800
  }];

  // options
  public legend: boolean = true;
  public showLabels: boolean = true;
  public animations: boolean = true;
  public xAxis: boolean = true;
  public yAxis: boolean = true;
  public showYAxisLabel: boolean = true;
  public showXAxisLabel: boolean = true;
  public xAxisLabel: string = 'Time';
  public yAxisLabel: string = 'Valid Certifications';
  public timeline: boolean = false;

  public colorScheme = {
    // domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
    domain: ['#09cde7', '#0bc9a6', '#3d658d', '#1b6062', '#80093c', '#d8c463']
  };

  multi = [
    {
      "name": "Valid Certificates",
      "series": [
        // {
        //   "name": "1990",
        //   "value": 62000000
        // },
        // {
        //   "name": "2010",
        //   "value": 73000000
        // },
        // {
        //   "name": "2011",
        //   "value": 89400000
        // }
      ]
    }
  ];


  public view: any[] = [1000, 450];

  public certificateGroups: CertificateGroup[] = [];
  public soonExpiringCertificates: CertificateGroup[] = [];
  public allCertificates: Certificate[] = [];
  public usersPerCertificate: CertificateUserGroup[] = [];
  public allUsers: User[] = [];
  public expiringCertificates: ExpiringCertificate[] = [];

  public validCerts: any = [

  ];

  public summaryDef: any = {};
  public summary: any = {};

  constructor(private stateService: StateService) { }

  ngOnInit(): void {
    this.allUsers = this.stateService.getAllUsers();
    this.allCertificates = [].concat.apply([], this.allUsers.map(user => user.certificates));
    this.certificateGroups = this.groupCertificates(this.allCertificates);
    this.multi = this.certificateGroups.map(group => {
      return {
        name: group.name,
        series: this.generateSummaryFor(group)
      }
    });
    this.soonExpiringCertificates = this.soonExpiring(this.certificateGroups);
    this.usersPerCertificate = this.groupUsersByCertificate(this.allUsers);
    this.validCerts = this.usersPerCertificate.map(cg => {
      return {
        name: cg.name,
        value: cg.users.length
      }
    });

    this.expiringCertificates = StatisticsPageComponent.flatMap(this.allUsers.map(user => {
      return user.certificates.map(cert => {
        return {
          certificateName: cert.description,
          companyName: user.companyName,
          ownerName: user.fullname,
          expiresInMonths: moment(cert.expiryDate).diff(moment(), 'months'),
          expiryDate: cert.expiryDate
        };
      });
    })).filter(es => {
      return es.expiresInMonths >= 0 && es.expiresInMonths < 3 && es.companyName !== null;
    });

    this.summaryDef = {
      data: this.expiringCertificates,
      filter: {
      },
      grouping: [
      ],
      fields: [
        {
          label: 'In One Month',
          filter: es => es.expiresInMonths === 0,
          aggregate: 'count'
        },
        {
          label: 'In Two Months',
          filter: es => es.expiresInMonths === 1,
          aggregate: 'count'
        },
        {
          label: 'In Three Months',
          filter: es => es.expiresInMonths === 2,
          aggregate: 'count'
        }
      ],
      drillDownLevel: 0,
      drillDown: [
        {
          field: 'companyName',
          label: 'Client',
          aggregate: 'first'
        },
        {
          field: 'certificateName',
          label: 'Certificate',
          aggregate: 'first'
        },
        {
          field: 'ownerName',
          label: 'Certificate Owner',
          aggregate: 'first'
        }
      ]
    };

    this.summary = this.generateSummary();
  }

  public generateSummary(): any {
    let summary: any = this.summaryDef;
    let currentDrillDown = summary.drillDown[summary.drillDownLevel];

    // Filter
    let filteredData: any[] = summary.data.filter(entry => StatisticsPageComponent.objectMatches(entry, summary.filter));

    // Group
    let groups: any = [];
    filteredData.forEach(entry => {
      let matchingGroups = groups.filter(group => StatisticsPageComponent.objectMatches(entry, group.group));
      let matchingGroup = null;
      if(matchingGroups.length === 0) {
        // Create a matching group
        let groupDef = {};
        summary.grouping.forEach(field => {
          groupDef[field] = entry[field];
        });
        let drillDownField = currentDrillDown.field;
        groupDef[drillDownField] = entry[drillDownField];
        matchingGroup = {
          group: groupDef,
          data: []
        };
        groups.push(matchingGroup);
      }
      else {
        // Get the existing matching group
        matchingGroup = matchingGroups[0];
      }
      matchingGroup.data.push(entry);
    });

    // View
    let result = {
      headers: StatisticsPageComponent.flatMap([[currentDrillDown.label], summary.fields.map(field => field.label)]),
      values: groups.map(group => {
        let anie = [StatisticsPageComponent.fieldToValue(currentDrillDown, group)];
        let anies = summary.fields.map(field => StatisticsPageComponent.fieldToValue(field, group));
        return StatisticsPageComponent.flatMap([anie, anies]);
      })
    };

    return result;
  }

  private static fieldToValue(field, group): any {
    let aggregates = {
      first: (values: any[]) => values[0],
      count: (values: any[]) => values.length
    };
    let values: any[] = group.data;
    if(field.filter) {
      values = values.filter(field.filter);
    }
    let list: any[] = field.field ? values.map(value => value[field.field]) : values;
    return aggregates[field.aggregate](list);
  }

  public drillingHasBeenDone(): boolean {
    let summary: any = this.summaryDef;
    return summary.drillDownLevel > 0;
  }

  public drillIt(fieldValue): void {
    let summary: any = this.summaryDef;
    let currentDrillDown = summary.drillDown[summary.drillDownLevel];
    if(!summary.drillDown[summary.drillDownLevel+1])
      return;
    let field: string = currentDrillDown.field;
    let value: any = fieldValue[0];
    // apply the filter
    summary.filter[field] = value;
    // drill more!
    summary.drillDownLevel++;
    // Generate more summary
    this.summary = this.generateSummary();
  }

  public undoDrilling(): void {
    let summary: any = this.summaryDef;
    // Drill less
    summary.drillDownLevel--;
    let currentDrillDown = summary.drillDown[summary.drillDownLevel];
    let field: string = currentDrillDown.field;
    // Remove filter
    delete summary.filter[field];
    console.log(summary.filter);
    // Generate more summary
    this.summary = this.generateSummary();
  }

  public drillingBreadcrumb(): any[] {
    let summary: any = this.summaryDef;
    return summary.drillDown.slice(0, summary.drillDownLevel).map(dd => {
      return {
        label: dd.label,
        value: summary.filter[dd.field]
      };
    });
  }

  private static objectMatches(object: any, filterObject: any) {
    for(let field in filterObject) {
      if(filterObject.hasOwnProperty(field) && filterObject[field] !== object[field])
        return false;
    }
    return true;
  }

  private static flatMap<T>(listOfLists: T[][]): T[] {
    return [].concat.apply([], listOfLists);
  }

  public soonExpiring(certificateGroups: CertificateGroup[]): CertificateGroup[] {
    return certificateGroups.map(cg => {
      return  {
        name: cg.name,
        certificates: cg.certificates.filter(c => {
          let expDate = moment(c.expiryDate);
          return expDate.isAfter(moment()) && expDate.isBefore(moment().add(30, 'days'));
        })
      };
    });
  }



  public getPercentage(cg: CertificateGroup): string {
    return Math.round((cg.certificates.length / this.allCertificates.length) * 100) + "%";
  }

  onSelect(event) {
    console.log(event);
  }

  private generateSummaryFor(certificateGroup: CertificateGroup): any {
    let allCertificates: Certificate[] = certificateGroup.certificates;
    let validitySummary: CertificateValiditySummary[] = [];
    // Calculate first entry
    let now: Moment = moment();
    let numValid = this.numValidAfter(allCertificates, now);
    let currentEntry: CertificateValiditySummary = {
      date: now.toDate(),
      numValid: numValid,
      numExpired: allCertificates.length - numValid
    };
    let until: Moment = moment().add(1, "year");

    for (var m = now; m.isBefore(until); m.add(1, 'days')) {
      let numValid = this.numValidAfter(allCertificates, m);
      validitySummary.push({
        date: m.toDate(),
        numValid: numValid,
        numExpired: allCertificates.length - numValid
      });
    }

    let result = validitySummary.map(s => {
      return {
        "name": s.date, // moment(s.date).format("YYYY-MM-DD"),
        "value": s.numValid // 100 * s.numValid / (s.numValid + s.numExpired)
      };
    });
    return result;
  }

  private groupCertificates(allCertificates: Certificate[]): CertificateGroup[] {
    let result: CertificateGroup[] = [];
    let groups = this.groupBy(allCertificates, c => c.description);
    for(let name in groups) {
      result.push({
        name: name,
        certificates: groups[name]
      });
    }
    return result;
  }

  private groupUsersByCertificate(allUsers: User[]): CertificateUserGroup[] {
    let collector: any = {};
    allUsers.forEach(u => {
      u.certificates.forEach(c => {
        if(!(c.description in collector)) {
          collector[c.description] = [];
        }
        collector[c.description].push(u);
      });
    });
    let result: CertificateUserGroup[] = [];
    for(let name in collector) {
      result.push({
        name: name,
        users: collector[name]
      });
    }
    return result;
  }

  private numValidAfter(allCertificates: Certificate[], date: Moment): number {
    return allCertificates.filter(cert => {
      return moment(cert.expiryDate).isAfter(date);
    }).length;
  }

  private groupBy<T>(list: T[], keyGetter: (object: T) => string): any {
    const map = {};
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map[key];
      if (!collection) {
        map[key] =  [item];
      } else {
        collection.push(item);
      }
    });
    return map;
  }

}
